import { Link } from "react-router-dom";

const SiteFooter = () => {
  return (
    <footer className="footer">
      <Link to={"/"}>Homepage</Link>
      <Link to={"/About"}>About</Link>
      ©Blogy 2022. Created and Published by{" "}
      <a href="https://abdurrahmanhassan.netlify.app">Abdurrahman Hassan</a>
    </footer>
  );
};

export default SiteFooter;
